import React from 'react'
import {
    Card,
    CardBody,
    CardImg,
    //  Col 
} from 'reactstrap'
import { withTranslation } from 'react-i18next'
import { PlayCircle } from "phosphor-react"
import PropTypes from 'prop-types'
import Skeleton from '../UI/Skeleton'

class NewsMiniCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
    }

    render() {
        const { t } = this.props
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <div className={`${this.props.noCol ? '' : 'col-sm-12 col-md-6 col-lg-6 col-xl-4 d-flex align-items-stretch'}`}>
                            <Card className="news-mini-card d-flex flex-column">
                                <Skeleton height={150} />
                                <CardBody>
                                    <Skeleton className="title lg-font-size" style={{ paddingTop: '5px' }} count={2} />
                                    <Skeleton className="desc md-font-size" style={{ paddingTop: 0 }} count={5} />
                                </CardBody>
                                <Skeleton className="card-bottom mt-auto text sm-font-size minicard-route" style={{ marginLeft: '20px', marginBottom: '20px', paddingTop: '10px' }} width={'50%'} />
                            </Card>
                        </div>
                        :
                        <div className={`${this.props.noCol ? '' : 'col-sm-12 col-md-6 col-lg-6 col-xl-4 d-flex align-items-stretch'}`}>
                            <Card className="news-mini-card d-flex flex-column">
                                <CardImg src={this.props.image ? `${this.state.imageUrl}/${this.props.image}` : "data:,"} alt="" onClick={() => {
                                    this.props.props.history.push(`/new/${this.props.id}`)
                                    window.location.reload()
                                }}></CardImg>
                                <CardBody>
                                    <div className="title lg-font-size">{this.props.title}</div>
                                    <div className="desc md-font-size" dangerouslySetInnerHTML={{ __html: this.props.desc || t('news-short-desc') }}></div>

                                </CardBody>
                                <div className="card-bottom mt-auto">
                                    <a className="minicard-route p-20" href={`/new/${this.props.id}`}>
                                        <PlayCircle size={20} className="icon" />
                                        <span className="text sm-font-size">{t('news-read-more')}</span>
                                    </a>
                                </div>
                            </Card>
                        </div>
                }
            </React.Fragment>

        )
    }
}

NewsMiniCard.propTypes = {
    props: PropTypes.object,
    t: PropTypes.func,
    id: PropTypes.number,
    image: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    noCol: PropTypes.bool,
    skeleton: PropTypes.bool,
}

export default withTranslation()(NewsMiniCard)



// WEBPACK FOOTER //
// ./src/components/News/NewsMiniCard.jsx